import { guideSteps } from "@/mocks/mangaData";

export default function Guide() {
  return (
    <section id="guide" className="relative py-12 md:py-20 bg-background-50 overflow-hidden">
      <div className="absolute -top-10 -right-10 w-64 h-64 rounded-full bg-accent-100/60 blur-2xl"></div>
      <div className="absolute -bottom-10 -left-10 w-64 h-64 rounded-full bg-primary-100/50 blur-2xl"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-8 md:mb-14">
          <span className="inline-flex items-center gap-1.5 text-secondary-600 text-sm font-medium">
            <i className="ri-compass-3-line"></i>
            入坑指南
          </span>
          <h2 className="mt-2 font-display text-2xl md:text-4xl text-foreground-950">
            四步挑到你的本命漫
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            怕踩雷？按这套标准挑，从画风到剧情都不出错，入坑作也能变成一生推。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {guideSteps.map((s, idx) => (
            <div
              key={s.id}
              className="relative p-5 md:p-6 rounded-xl bg-background-100/70 border border-background-200/70 hover:border-accent-300 transition-colors"
            >
              <span className="absolute top-5 right-5 font-display text-4xl text-foreground-200/70">
                {String(idx + 1).padStart(2, "0")}
              </span>
              <span
                className={`w-12 h-12 rounded-xl flex items-center justify-center text-background-50 ${
                  idx % 2 === 0 ? "bg-primary-500" : "bg-accent-500"
                }`}
              >
                <i className={`${s.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-display text-lg text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#recommend"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-lg bg-secondary-500 text-background-50 text-sm font-medium hover:bg-secondary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-heart-3-line"></i>
            按这套标准挑本命
          </a>
        </div>
      </div>
    </section>
  );
}